export const FETCH_REGIONAL_AND_LANGUAGE_ALL_START = 'FETCH_REGIONAL_AND_LANGUAGE_ALL_START';
export const FETCH_REGIONAL_AND_LANGUAGE_ALL_ERROR = 'FETCH_REGIONAL_AND_LANGUAGE_ALL_ERROR';
export const RECEIVE_REGIONAL_AND_LANGUAGE_ALL = 'RECEIVE_REGIONAL_AND_LANGUAGE_ALL';
export const CLEAR_REGIONAL_AND_LANGUAGE_ALL_STORE = 'CLEAR_REGIONAL_AND_LANGUAGE_ALL_STORE';

export const FETCH_SETTINGS_LANGUAGES_START = 'FETCH_SETTINGS_LANGUAGES_START';
export const FETCH_SETTINGS_LANGUAGES_ERROR = 'FETCH_SETTINGS_LANGUAGES_ERROR';
export const RECEIVE_SETTINGS_LANGUAGES = 'RECEIVE_SETTINGS_LANGUAGES';
export const CLEAR_SETTINGS_LANGUAGES_STORE = 'CLEAR_SETTINGS_LANGUAGES_STORE';

export const FETCH_SETTINGS_PRESETS_START = 'FETCH_SETTINGS_PRESETS_START';
export const FETCH_SETTINGS_PRESETS_ERROR = 'FETCH_SETTINGS_PRESETS_ERROR';
export const FETCH_SETTINGS_PRESETS_NOT_FOUND = 'FETCH_SETTINGS_PRESETS_NOT_FOUND';
export const RECEIVE_SETTINGS_PRESETS = 'RECEIVE_SETTINGS_PRESETS';
export const CLEAR_SETTINGS_PRESETS_STORE = 'CLEAR_SETTINGS_PRESETS_STORE';

export const SAVE_SETTINGS_PRESET_START = 'SAVE_SETTINGS_PRESET_START';
export const SAVE_SETTINGS_PRESET_SUCCESSFUL = 'SAVE_SETTINGS_PRESET_SUCCESSFUL';
export const SAVE_SETTINGS_PRESET_ERROR = 'SAVE_SETTINGS_PRESET_ERROR';

export const CLEAR_SETTINGS_PRESET_DETAILS = 'CLEAR_SETTINGS_PRESET_DETAILS';
export const INIT_STATE_SETTINGS_PRESET_DETAILS = 'INIT_STATE_SETTINGS_PRESET_DETAILS';

export const DELETE_SETTINGS_PRESET_START = 'DELETE_SETTINGS_PRESET_START';
export const DELETE_SETTINGS_PRESET_SUCCESSFUL = 'DELETE_SETTINGS_PRESET_SUCCESSFUL';
export const DELETE_SETTINGS_PRESET_ERROR = 'DELETE_SETTINGS_PRESET_ERROR';

export const ADD_PRESET_TO_PRESETS_LIST = 'ADD_PRESET_TO_PRESETS_LIST';
export const REMOVE_PRESET_FROM_PRESETS_LIST = 'REMOVE_PRESET_FROM_PRESETS_LIST';



// WEBPACK FOOTER //
// ./src/store/modules/settings/mutation-types.js